<template>
  <home-layout>
    <v-card>
      <v-card-title>
        <h1>Currency Converter</h1>
      </v-card-title>
      <v-card-text>
        <v-btn color="blue" dark @click="$router.push('/currencies')">
          List of currencies
        </v-btn>
      </v-card-text>
    </v-card>
    <convert-box />
    
  </home-layout>
</template>

<script>
import ConvertBox from 'component/converter/ConvertBox'

export default {
  components: {
    ConvertBox
  }  
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/index.vue